import script from "./LeftSidebarOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarOverview.vue?vue&type=script&setup=true&lang=js"

import "./LeftSidebarOverview.vue?vue&type=style&index=0&id=dc20028c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc20028c"]])

export default __exports__